import { BellFilled, BellOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import { useGetNotifications } from "apps/CustomerPanel/Notification/ServerSideStates";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NotificationCount = () => {
  const navigate = useNavigate();
  const notifications = useGetNotifications();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (notifications?.data?.data) {
      let allList = notifications?.data?.data?.filter((item:any)=>!item.isRead) || [];
      setCount(allList?.length);
    }
  }, [notifications?.data]);
  return (
    <>
      <div
      className="!hidden lg:!block"
        onClick={() => {
          navigate(`/admin/panel?activePanelMenu=notification`);
        }}
      >
        {count ? (
          <>
          
            <Badge count={count}>
              <BellFilled className="!text-xl hover:cursor-pointer !text-red-500" />
            </Badge>
          </>
        ) : (
          <>
            <BellOutlined className="!text-xl hover:cursor-pointer " />
          </>
        )}
      </div>
    </>
  );
};

export default NotificationCount;
